import { Component, inject, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MarkDoneBlocksPipe, TranslationKeyPipe } from '../../pipes';
import { QuestionFlowService } from '../../services';

@Component({
    selector: 'ca-flow-timeline',
    imports: [TranslateModule, MarkDoneBlocksPipe, MatIconModule, TranslationKeyPipe],
    templateUrl: './flow-timeline.component.html',
    styleUrl: './flow-timeline.component.scss'
})
export class FlowTimelineComponent {
    public timelinePreview = input<boolean>(false);
    public service = inject(QuestionFlowService);
    public dialog = inject(MatDialog);

    async openTimelineOverlay(): Promise<void> {
        // dynamic import breaks the circular dependency
        const { FlowTimelineOverlayComponent } = await import('../flow-timeline-overlay/flow-timeline-overlay.component');
        this.dialog.open(FlowTimelineOverlayComponent, {
            panelClass: 'ca-flow-timeline-overlay',
            maxWidth: '610px',
            width: '100%',
            height: '100%'
        });
    }
}
